import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { ExpiredGmailTracker } from '@app/models';

export interface ExpiredGmailTrackerApi {
  items: ExpiredGmailTracker[];
  total_count: number;
}

@Injectable({ providedIn: 'root' })
export class ExpiredGmailTrackerService {
  private _apiRoute = '/api/expired-gmail-trackers/';
  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  private currentTrackerBeingViewed: ExpiredGmailTracker = null;

  constructor(
    private httpClient: HttpClient,
  ) { }


  setCurrentBeingViewed(_tutorial: ExpiredGmailTracker): void {
    this.currentTrackerBeingViewed = _tutorial;
  }

  getCurrentBeingViewed(): ExpiredGmailTracker {
    return this.currentTrackerBeingViewed;
  }


  getAll(): Observable<ExpiredGmailTracker[]> {
    return this.httpClient.get<ExpiredGmailTracker[]>(this._apiRoute);
  }


  getByUserId(_userId: string): Observable<ExpiredGmailTracker> {
    return this.httpClient.get<ExpiredGmailTracker>(this._apiRoute + 'user-id/' + _userId);
  }


  get(_id: string): Observable<ExpiredGmailTracker> {
    return this.httpClient.get<ExpiredGmailTracker>(this._apiRoute + _id);
  }


  update(_seasonStandings: ExpiredGmailTracker): Observable<ExpiredGmailTracker> {
    return this.httpClient.put<any>(this._apiRoute + _seasonStandings._id, JSON.stringify(_seasonStandings), this.headerOptions);
  }


  search(searchTerms: any): Observable<ExpiredGmailTracker[]> {
    return this.httpClient.post<ExpiredGmailTracker[]>(this._apiRoute + 'search', JSON.stringify(searchTerms), this.headerOptions);
  }


  selectAllSearch(searchTerms: ExpiredGmailTracker): Observable<ExpiredGmailTracker[]> {
    searchTerms['selectAll'] = true;
    return this.httpClient.post<ExpiredGmailTracker[]>(this._apiRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
  }


  getDatasource(searchParams, sortField = 'createdAt', sortDirection = 'desc', pageNumber: number = 0, pageSize: number = 10): Observable<ExpiredGmailTrackerApi> {
    searchParams['selectAll'] = false;

    searchParams.sortField = sortField;
    searchParams.sortOrder = sortDirection;
    searchParams.pageNumber = pageNumber;
    searchParams.pageSize = pageSize;

    return this.httpClient.post<ExpiredGmailTrackerApi>(this._apiRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
  }


  create(_seasonStandings: ExpiredGmailTracker): Observable<ExpiredGmailTracker> {
    return this.httpClient.post<ExpiredGmailTracker>(this._apiRoute, JSON.stringify(_seasonStandings), this.headerOptions);
  }


  deleteByIdArray(arrayOfIds): Observable<any> {
    const deleteRequest = {ids: arrayOfIds};
    return this.httpClient.post<any>(this._apiRoute + 'delete-by-array', JSON.stringify(deleteRequest), this.headerOptions);
  }


  delete(id: string): Observable<any> {
    return this.httpClient.delete(this._apiRoute + '/' + id, this.headerOptions);
  }
}